import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RelativeLink from "../common/RelativeLink";
import * as types from "../../constants/ComponentConstants";

import redirector from "../../util/redirector.js";
import AutoBindComponent from "../common/AutoBindComponent";
import * as aanvraagActions from "../../actions/aanvraagActions";
import * as layoutActions from "../../actions/layoutActions";
import Button from "../common/Button";
import Section from "../common/Section";
import Fieldset from "../common/Fieldset";
import * as DomainConstants from "../../constants/DomainConstants";
const editPageUrl = "aanvraag/";
const pdfUrl = "Home/Print/";

class HomePage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);
	}

	componentWillMount() {
		this.props.loadLayout();
		if (this.props.aanvraagId) {
			const aanvraagId = this.props.aanvraagId;
			this.props.loadAanvraag(aanvraagId);
		}
	}

	handleOnGoToAanvraag(type) {
		const clearAanvraag = this.props.clearAanvraag;

		return function () {
			clearAanvraag();
			redirector.goTo('/aanvraag/nieuw/' + type);
		};
	}

	handleOnGoToAanvraagBovenlokaal() {
		const clearAanvraag = this.props.clearAanvraag;

		return function () {
			clearAanvraag();
			redirector.goTo('/aanvraag/nieuw');
		};
	}

	handleOnGoToSimulatieDossier() {
		return function () {
			redirector.goTo('/simulatiedossier/nieuw/');
		};
	}

	render() {
		const aanvraag = this.props.aanvraag.item;
		const type = this.props.type;
		let dossierButtons = "";

		if (aanvraag) {
			const dossierNaam = aanvraag.naam;

			dossierButtons = (
				<Section title="Test Dossier" color={types.COLOR_BLUE}>
					<Fieldset>
						Het dossier met id '{this.props.aanvraagId}' naam '{dossierNaam}' zit nu in de store, klik op
						een knop naar keuze om een pagina te testen met het ingeladen dossier.
						<br />
						<RelativeLink to="/aanvraag/bevestiging" title="test" className="c-button">Go To
							Aanvraag/Bevestiging</RelativeLink>
						<br />
						-- Add other testLinks here --
					</Fieldset>
				</Section>);
		}
		const aanvraagButtons = (
			<Section title="Nieuwe Aanvraag" color={types.COLOR_BLUE}>
				<Fieldset>
					<Button
						onClick={this.handleOnGoToAanvraagBovenlokaal()}
						text="Aanvraag BovenLokaal" />
					<br />
					<br />
					<Button
						onClick={this.handleOnGoToAanvraag(DomainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE)}
						text="Aanvraag Topsport" />
					<br />
					<br />
					<Button
						onClick={this.handleOnGoToSimulatieDossier()}
						text="Simulatie Dossier Bovenlokaliteit" />
					<br />
					<br />
				</Fieldset>
			</Section>);


		return <div>{dossierButtons}{aanvraagButtons}</div>;
	}
}

HomePage.propTypes = {
	aanvraag: PropTypes.object
};

function mapStateToProps(state, ownProps) {
	return {
		aanvraagId: ownProps.params.id,
		aanvraag: state.aanvraag,
		type: ownProps.params.type
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadAanvraag: bindActionCreators(aanvraagActions.loadAanvraag, dispatch),
		clearAanvraag: bindActionCreators(aanvraagActions.clearAanvraag, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadTestPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
